/* eslint-disable @typescript-eslint/naming-convention */
export interface InstallationMaalerAflaesningTaellevaerkDto {
    enhedvaerdi: string;
    enhedtype: string;
    enhed: string;
}

export interface InstallationMaalerAflaesningDto {
    ejendomnr: number;
    aktivnr: number;
    taellevaerker: InstallationMaalerAflaesningTaellevaerkDto[];
    i_nr: number;
    dato: string;
    maalerTypeId: number;
    maalerNr: string;
}
